var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSocialFb = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.305 16V8.702h2.579l.387-2.845H6.305V4.041c0-.823.24-1.384 1.485-1.384l1.585-.001V.111A22.626 22.626 0 0 0 7.065 0C4.777 0 3.212 1.326 3.212 3.76v2.097H.625v2.845h2.587V16h3.093Z",
  fill: "#2C4145"
})));
export default SvgSocialFb;